import { ExtractEncryptionMode } from './SitePropertyTypes';
import { UserVisibilityMode } from '../settings/types/ISiteSettingsForSiteAdmin';

export function isExtractEncryptionModeEnabled(extractEncryptionMode: ExtractEncryptionMode): boolean {
  if (extractEncryptionMode === ExtractEncryptionMode.ENABLED) {
    return true;
  }
  return false;
}

export function isUserVisibilityLimited(userVisibilityMode: UserVisibilityMode): boolean {
  return userVisibilityMode === UserVisibilityMode.LIMITED;
}
